import { Box, Typography } from "@mui/material";

interface CustomDisabledInputProps {
  label: string;
  value: string;
}

export const CustomDisabledInput = (props: CustomDisabledInputProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        padding: "8px",
        border: "2px solid #e0e0e000",
        borderRadius: "8px",
        position: "relative",
      }}>
      <Typography variant="body2" sx={{ fontSize: "14px", textTransform: "uppercase" }}>
        {props.label}
      </Typography>
      <Typography variant="body2" sx={{ marginTop: "8px", fontSize: "16px" }}>
        {props.value}
      </Typography>
    </Box>
  );
};
